export default __webpack_public_path__ + "static/startup-6b75a03e75ab5a8240d2a969c2861e2b.jpg";